import { render, staticRenderFns } from "./favoris.vue?vue&type=template&id=6ebf560b"
import script from "./favoris.js?vue&type=script&lang=js&external"
export * from "./favoris.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports